import React from "react";
import { ReactComponent as EmptyImg } from "../../assets/illustrations/empty-96x96.svg";
import { Button, Icon } from "../common";

type Props = {
  createInvoiceHandler: () => void;
};

export const NoInvoices: React.FC<Props> = ({ createInvoiceHandler }) => {
  return (
    <div className="bg-slate-100 rounded-2xl p-6 md:px-12 md:py-16 flex flex-col items-center justify-center">
      <div className="max-w-[400px] text-center flex flex-col items-start md:items-center">
        <EmptyImg />

        <div className="text-base text-gray-500 mb-4 mt-4 md:mt-9">
          Interesting fact
        </div>

        <div className="text-base text-gray-300 mb-8 md:mb-4 text-left md:text-center">
          We auto-save the invoice when you are working on it so you don't lose
          anything
        </div>

        <Button
          variant={Button.variant.SECONDARY}
          onClick={createInvoiceHandler}
        >
          <span className="flex flex-row gap-x-2">
            Create your first invoice{" "}
            <Icon
              icon="Arrow-right"
              size={24}
              className="text-gray-500"
              disableFill
            />
          </span>
        </Button>
      </div>
    </div>
  );
};
